import { InvestmentReportContainerService } from './investment-report-container.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { InvestmentReportComponent } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-investment-report-container',
  template: `<fcp-investment-report
    [data]="data"
    (sendCompanySelected)="getYearsList($event)"
    (sendYearSelected)="getMonthsList($event)"
    (sendMonthSelected)="getFilesList($event)"
    (sendFileSelected)="getFile($event)"
  ></fcp-investment-report>`,
})
export class InvestmentReportContainerComponent implements OnInit {

  public data: any;
  public listFile: any;
  private months: any;
  @ViewChild(InvestmentReportComponent) investmentReport: any;

  constructor(private service: InvestmentReportContainerService) {
    this.data = {
      title: 'INVESTIMENTOS',
      subTitle: 'Demonstrativo de Investimentos',
      loading: false
    }
    this.months = [
      { month: 1, description: 'Janeiro' },
      { month: 2, description: 'Fevereiro' },
      { month: 3, description: 'Março' },
      { month: 4, description: 'Abril' },
      { month: 5, description: 'Maio' },
      { month: 6, description: 'Junho' },
      { month: 7, description: 'Julho' },
      { month: 8, description: 'Agosto' },
      { month: 9, description: 'Setembro' },
      { month: 10, description: 'Outubro' },
      { month: 11, description: 'Novembro' },
      { month: 12, description: 'Dezembro' }
    ]
  }

  public ngOnInit(): void {
    this.getCompanies();
  }

  public getCompanies() {
    this.data.loading = true;
    this.service.getIRCompany().subscribe(resp => {
      this.data.companies = resp;
      this.data.showCompanyList = false;
      this.data.loading = false;
    });
  }

  public getYearsList(company: string) {
    let listYears = [];
    this.service.getIRPeriod(company).subscribe(resp => {
      this.data.companyPeriod = resp;
      this.data.companySelected = company;
      this.data.companyPeriod.forEach(item => {
        if (listYears.indexOf(item.year) == -1) {
          listYears.push(item.year)
        }
      });
      this.data.listYears = listYears;
      this.data.loading = false;
      this.investmentReport.data = this.data;
    });
  }

  public getMonthsList(yearSelected: any) {
    let listMonths = [];
    this.data.yearSelected = yearSelected.value;
    this.data.companyPeriod.map(item => {
      if (item.year == yearSelected.value) {
        let pos = this.months.findIndex(obj => obj.month == item.month)
        listMonths.push(this.months[pos]);
      }
    });
    this.data.listMonths = listMonths.sort((a, b) => a.month - b.month);
    this.investmentReport.data = this.data;
  }

  public getFilesList(monthSelected: any) {
    this.listFile = [];
    this.data.monthSelected = monthSelected.value;
    this.service.getIRInvestmentReportList(this.data.companySelected, this.data.yearSelected, this.data.monthSelected)
      .subscribe(res => {
        this.data.listFiles = res;
        this.data.showlistFiles = true;
        this.data.loading = false;
        this.investmentReport.data = this.data;
      });
  }

  public getFile(fileInfo: any) {
    this.service.getIRDocInvestmentReport(fileInfo.company, fileInfo.year, fileInfo.month, fileInfo.name)
      .subscribe(file => {
        const downloadURL = window.URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = this.service.getFileName(fileInfo);
        this.data.loading = false;
        link.click();
      });
  }

}
